import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $gateways,
  $totalCountOfGateways,
  gatewaysListMounted,
  getGateways,
} from './model'
import { GatewayRequest } from './types'
import { $totalCountOfClients } from '../../clients/list/model'

export const useGatewaysList = () => {
  const onChangeGatewaysList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }: GatewayRequest) => {
    gatewaysListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
      filters,
    })
  }

  const gateways = useStore($gateways)
  const totalCountOfGateways = useStore($totalCountOfGateways)
  const loading = useStore(getGateways.pending)
  return { gateways, totalCountOfGateways, loading, onChangeGatewaysList }
}
